import { gettext } from '@eventbrite/i18n';
import { Icon } from '@eventbrite/marmalade';
import classNames from 'classnames';
import React from 'react';
import { navigationLinkProps } from '../../../../types';
import styles from './NavLink.module.scss';

const NavLink = ({
    path,
    text,
    textColor,
    iconType,
    iconPosition,
    className,
}: navigationLinkProps) => {
    const navLinkClass = classNames(styles.main, className);
    const iconPositionClass = iconPosition === 'right' ? styles.iconRight : '';

    return (
        <a
            className={navLinkClass}
            href={path}
            data-testid="navLink"
            aria-label={gettext('link')?.toString()}
        >
            {!!iconType && (
                <span data-testid="navLink-icon" className={iconPositionClass}>
                    <Icon>
                        <>{iconType}</>
                    </Icon>
                </span>
            )}
            <span style={{ color: textColor }}>{text}</span>
        </a>
    );
};

export default NavLink;
